import { render, staticRenderFns } from "./contactCard.vue?vue&type=template&id=7d479420&scoped=true"
import script from "./contactCard.vue?vue&type=script&lang=js"
export * from "./contactCard.vue?vue&type=script&lang=js"
import style0 from "./contactCard.vue?vue&type=style&index=0&id=7d479420&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d479420",
  null
  
)

export default component.exports